import { render } from "./ErrorPrompt.vue?vue&type=template&id=09240c46&scoped=true"
import script from "./ErrorPrompt.vue?vue&type=script&lang=js"
export * from "./ErrorPrompt.vue?vue&type=script&lang=js"

import "./ErrorPrompt.vue?vue&type=style&index=0&id=09240c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09240c46"]])

export default __exports__